$(document).ready(function(){
    if (window.innerWidth < 768) {
        $('.hero-three-blocks__content--carousel').slick({
            dots: false,
            arrows: false,
            infinite: true,
            speed: 300,
            variableWidth: true,
            slidesToShow: 3,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    }
});
